/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconLevelTwo: {
  name: 'level_two';
  data: string;
} = {
  name: 'level_two',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M26.602 311.333c0 4.225-3.211 7.65-7.172 7.65s-7.172-3.425-7.172-7.65 3.211-7.65 7.172-7.65 7.172 3.425 7.172 7.65z" transform="matrix(15 0 0 15 14.54 -4364)"/><path d="M19.431 292.208c1.793 5.737 3.586 5.737 3.586 9.563 0 0-1.793 1.913-3.586 1.913s-3.586-1.913-3.586-1.913c0-3.825 1.793-3.825 3.586-9.563zM19.431 330.458c-1.793-5.737-3.586-5.737-3.586-9.563 0 0 1.793-1.913 3.586-1.913s3.586 1.913 3.586 1.913c0 3.826-1.793 3.826-3.586 9.563z" transform="matrix(15 0 0 15 14.54 -4364)"/></svg>`,
};
